import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../instance";

const url = process.env.REACT_APP_API_BASE_URL;

const initialState = {
  loading: false,
  dropLoading: false,
  loadingGrid:false,
  loadingGenerateReport:false,
  data: {},
  counties: [],
  crops: [],
  count: {},
  wtrSources: [],
  irrType: [],
  schemeType: [],
  loship: [],
  schemeCrop: [],
  iwuaLicenses: [],
  schemeBlocks: [],
  periods: [],
  memberTypes: [],
  subCounties: [],
  locations: [],
  subLocations: [],
  subsidyTypes: [],
  subsidySources: [],
  wtrFunding: [],
  wtrConvMeans: [],
  wtrAppl: [],
  wtrAbstraction: [],
  mrktHow:[],
  mngrCrops:[],
  department:[],
  usrStatuses:[],
  profiles:[],
  reportTree:[],
  lovData:[],
  lovGrid:[],
};

export const fetchData = createAsyncThunk(
  "fetch/fetchData",
  async (data, { rejectWithValue }) => {
    const { url, ...body } = data;
 
    await new Promise((resolve) => setTimeout(resolve, 0));

    try {
      const response = await axiosInstance({
        url,
        method: "POST",
        data: Object.keys(body).length ? body : null,
      }); 
      if (!response.data.success) {
        return {
          key: url,
          data: [],
          total: 0,
        };
      }

      return {
        key: url,
        data: response?.data?.data?.result,
        total: response?.data?.total,
      }; 
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
 

export const fetchCounties = createAsyncThunk(
  "dropdownSlice/fetchCounties",
  async (data, { rejectWithValue }) => {
    await new Promise((resolve) => setTimeout(resolve, 0));

    try {
      console.log("redux")
      const response = await axiosInstance.get(`/auth/counties/get`);
      return response.data.data.result;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const fetchSubCounties = createAsyncThunk(
  "dropdownSlice/fetchSubCounties",
  async (data, { rejectWithValue }) => {
    await new Promise((resolve) => setTimeout(resolve, 0));

    try {
      const response = await axiosInstance.get(
        `/api/sub_county/${data?.subCountyId}`
      );
      return response.data.data.result;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchLocation = createAsyncThunk(
  "dropdownSlice/fetchLocation",
  async (data, { rejectWithValue }) => {
    await new Promise((resolve) => setTimeout(resolve, 0));

    try {
      const response = await axiosInstance.get(
        `/api/location/${data?.locSubId}`
      );
      return response.data.data.result;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchSubLocation = createAsyncThunk(
  "dropdownSlice/fetchSubLocation",
  async (data, { rejectWithValue }) => {
    await new Promise((resolve) => setTimeout(resolve, 0));

    try {
      const response = await axiosInstance.get(
        `/api/sub_location/${data?.slocLocId}`
      );
      return response.data.data.result;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

 
export const fetchCrops = createAsyncThunk(
  "dropdownSlice/fetchCrops",
  async (data, { rejectWithValue }) => {
    await new Promise((resolve) => setTimeout(resolve, 0));

    try {
      const response = await axiosInstance.get(`/api/v2/flid/crops/get`);
      return response.data.data.result;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const fetchWaterSources = createAsyncThunk(
  "dropdownSlice/fetchWaterSources",
  async (data, { rejectWithValue }) => {
    await new Promise((resolve) => setTimeout(resolve, 0));

    try {
      const response = await axiosInstance.get(`/sch/water_sources`);
      return response.data.data.result;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchIrrigationType = createAsyncThunk(
  "dropdownSlice/fetchIrrigationType",
  async (data, { rejectWithValue }) => {
    await new Promise((resolve) => setTimeout(resolve, 0));

    try {
      const response = await axiosInstance.get(`/sch/irrigation_types`);
      return response.data.data.result;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchSchemeType = createAsyncThunk(
  "dropdownSlice/fetchSchemeType",
  async (data, { rejectWithValue }) => {
    await new Promise((resolve) => setTimeout(resolve, 0));

    try {
      const response = await axiosInstance.get(`/api/v2/flid/schemeType/get`);
      return response.data.data.result;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const fetchLoship = createAsyncThunk(
  "dropdownSlice/fetchLoship",
  async (data, { rejectWithValue }) => {
    await new Promise((resolve) => setTimeout(resolve, 0));

    try {
      const response = await axiosInstance.get(`/api/v2/flid/loship/get`);
      return response.data.data.result;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const fetchSchemeCrops = createAsyncThunk(
  "dropdownSlice/fetchSchemeCrops",
  async (data, { rejectWithValue }) => {
    await new Promise((resolve) => setTimeout(resolve, 0));

    try {
      const response = await axiosInstance.get(
        `/crop/get_scheme_crops/${data?.blkcSchId}`
      );
      return response.data.data.result;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const fetchLicense = createAsyncThunk(
  "dropdownSlice/fetchLicense",
  async (data, { rejectWithValue }) => {
    await new Promise((resolve) => setTimeout(resolve, 0));

    try {
      const response = await axiosInstance.get(`/api/licences`);
      return response.data.data.result;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const fetchSchemeBlocks = createAsyncThunk(
  "dropdownSlice/fetchSchemeBlocks",
  async (data, { rejectWithValue }) => {
    await new Promise((resolve) => setTimeout(resolve, 0));
    try {
      const response = await axiosInstance.get(
        `/sch/get_blocks/${data?.blocSchId}`
      );
      return response.data.data.result;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const fetchPeriods = createAsyncThunk(
  "dropdownSlice/fetchPeriods",
  async (data, { rejectWithValue }) => {
    await new Promise((resolve) => setTimeout(resolve, 0));
    try {
      const response = await axiosInstance.get(
        `/prod/get_periods/${data?.proSchId}`
      );
      return response.data.data.result;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const fetchMemberTypes = createAsyncThunk(
  "dropdownSlice/fetchMemberTypes",
  async (data, { rejectWithValue }) => {
    await new Promise((resolve) => setTimeout(resolve, 0));
    try {
      const response = await axiosInstance.get(`/api/member_type`);
      return response.data.data.result;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const fetchSubsidyType = createAsyncThunk(
  "dropdownSlice/fetchSubsidyType",
  async (data, { rejectWithValue }) => {
    await new Promise((resolve) => setTimeout(resolve, 0));
    try {
      const response = await axiosInstance.get(`/api/v2/flid/subsidyType`);
      return response.data.data.result;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const fetchSubsidySource = createAsyncThunk(
  "dropdownSlice/fetchSubsidySource",
  async (data, { rejectWithValue }) => {
    await new Promise((resolve) => setTimeout(resolve, 0));
    try {
      const response = await axiosInstance.get(`/api/v2/flid/subsidySource`);
      return response.data.data.result;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const fetchFundingMode = createAsyncThunk(
  "dropdownSlice/fetchFundingMode",
  async (data, { rejectWithValue }) => {
    await new Promise((resolve) => setTimeout(resolve, 0));
    try {
      const response = await axiosInstance.get(`/sch/funding_modes`);
      return response.data.data.result;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const fetchWtrConvMeans = createAsyncThunk(
  "dropdownSlice/fetchWtrConvMeans",
  async (data, { rejectWithValue }) => {
    await new Promise((resolve) => setTimeout(resolve, 0));
    try {
      const response = await axiosInstance.get(`/sch/water_conveying_means`);
      return response.data.data.result;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const fetchWtrApplMode = createAsyncThunk(
  "dropdownSlice/fetchWtrApplMode",
  async (data, { rejectWithValue }) => {
    await new Promise((resolve) => setTimeout(resolve, 0));
    try {
      const response = await axiosInstance.get(`/sch/water_application_mode`);
      return response.data.data.result;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const fetchWtrAbstraction = createAsyncThunk(
  "dropdownSlice/fetchWtrAbstraction",
  async (data, { rejectWithValue }) => {
    await new Promise((resolve) => setTimeout(resolve, 0));
    try {
      const response = await axiosInstance.get(`/sch/water_abstraction_modes`);
      return response.data.data.result;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchMrktHow = createAsyncThunk(
  "dropdownSlice/fetchMrktHow",
  async (data, { rejectWithValue }) => {
    await new Promise((resolve) => setTimeout(resolve, 0));
    try {
      const response = await axiosInstance.get(`/api/how_do_you_market`);
      return response.data.data.result;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchMangrCrops = createAsyncThunk(
  "dropdownSlice/fetchMangrCrops",
  async (data, { rejectWithValue }) => {
    await new Promise((resolve) => setTimeout(resolve, 0));
    try {
      const response = await axiosInstance.get(`/api/v2/flid/crops/get/${data?.schId}`);
      return response.data.data.result;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const fetchDepts = createAsyncThunk(
  "dropdownSlice/fetchDepts",
  async (data, { rejectWithValue }) => {
    await new Promise((resolve) => setTimeout(resolve, 0));
    try {
      const response = await axiosInstance.get(`/usr/departments`);
      return response.data.data.result;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const fetchUsrStatus = createAsyncThunk(
  "dropdownSlice/fetchUsrStatus",
  async (data, { rejectWithValue }) => {
    await new Promise((resolve) => setTimeout(resolve, 0));
    try {
      const response = await axiosInstance.get(`/usr/status`);
      return response.data.data.result;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const fetchProfiles = createAsyncThunk(
  "dropdownSlice/fetchProfiles",
  async (data, { rejectWithValue }) => {
    await new Promise((resolve) => setTimeout(resolve, 0));
    try {
      const response = await axiosInstance.get(`/usr/profiles`);
      return response.data.data.result;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const fetchFiles = createAsyncThunk(
  "dropdownSlice/fetchFiles",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/file/${data?.file}`, {
        responseType: "blob",  
      });
 
      const blob = new Blob([response.data], { type: response.data.type });
      const fileUrl = window.URL.createObjectURL(blob);
      return fileUrl;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const fetchFilesSecured = createAsyncThunk(
  "dropdownSlice/fetchFilesSecured",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/file/secured/${data?.file}`, {
        responseType: "blob",  
      });
 
      const blob = new Blob([response.data], { type: response.data.type });
      const fileUrl = window.URL.createObjectURL(blob);
      return fileUrl;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


export const fetchReportTree = createAsyncThunk(
  "saveSlice/fetch/fetchReportTree",
  async (data, { rejectWithValue }) => {
    let saveUrl = data.url;
    delete data.url;
    try {
      const response = await axiosInstance.post(`${url}/${saveUrl}`, data);
      if (!response.data.success) {
        return rejectWithValue(response.data);
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const fetchLovData = createAsyncThunk(
  "saveSlice/fetch/fetchLovData",
  async (data, { rejectWithValue }) => {
    let saveUrl = data.url;
    delete data.url;
    try {
      const response = await axiosInstance.post(`${url}/${saveUrl}`, data);
      if (!response.data.success) {
        return rejectWithValue(response.data);
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const fetchLovGridData = createAsyncThunk(
  "saveSlice/fetch/fetchLovGridData",
  async (data, { rejectWithValue }) => {
    let saveUrl = data.url;
    delete data.url;
    try {
      const response = await axiosInstance.post(`${url}/${saveUrl}`, data);
      if (!response.data.success) {
        return rejectWithValue(response.data);
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const generateReport = createAsyncThunk(
	"sms/downloadExcel",
	async (data, { rejectWithValue }) => {
	let saveUrl = data.url;
	delete data.url;
	  try {
		const response = await axiosInstance.post(`${url}/${saveUrl}`, data, {
		  responseType: "blob",
		}); 
    return {
      data: response.data,
      headers: response.headers,
    }; 
	  } catch (error) {
		return rejectWithValue(error.response.data);
	  }
	}
  );

export const fetchSlice = createSlice({
  name: "fetch",
  initialState,
  reducers: {
    clearFetchObj: () => {
      return { ...initialState };
    },
    clearFetchObjByUrl: (state, action) => {
      const urlKey = action.payload;
      if (state.data[urlKey]) {
        delete state.data[urlKey];
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.loading = false;
        const { key, data, total } = action.payload;

        if (!state.data) state.data = {};
        if (!state.count) state.count = {};

        state.data = { ...state.data, [key]: data || [] };
        state.count = { ...state.count, [key]: total || 0 };
      })
      .addCase(fetchData.rejected, (state, action) => {
        state.loading = false;
        const key = action.payload?.key || "unknown";

        if (!state.data) state.data = {};
        if (!state.count) state.count = {};

        state.data = { ...state.data, [key]: [] };
        state.count = { ...state.count, [key]: 0 };
      })

      .addCase(fetchCounties.pending, (state) => {
        state.dropLoading = true;
      })
      .addCase(fetchCounties.fulfilled, (state, action) => {
        state.dropLoading = false;
        state.counties = action.payload;
      })
      .addCase(fetchCounties.rejected, (state) => {
        state.dropLoading = false;
        state.counties = [];
      })

      .addCase(fetchSubCounties.pending, (state) => {
        state.dropLoading = true;
      })
      .addCase(fetchSubCounties.fulfilled, (state, action) => {
        state.dropLoading = false;
        state.subCounties = action.payload;
      })
      .addCase(fetchSubCounties.rejected, (state) => {
        state.dropLoading = false;
        state.subCounties = [];
      })

      .addCase(fetchLocation.pending, (state) => {
        state.dropLoading = true;
      })
      .addCase(fetchLocation.fulfilled, (state, action) => {
        state.dropLoading = false;
        state.locations = action.payload;
      })
      .addCase(fetchLocation.rejected, (state) => {
        state.dropLoading = false;
        state.locations = [];
      })

      .addCase(fetchSubLocation.pending, (state) => {
        state.dropLoading = true;
      })
      .addCase(fetchSubLocation.fulfilled, (state, action) => {
        state.dropLoading = false;
        state.subLocations = action.payload;
      })
      .addCase(fetchSubLocation.rejected, (state) => {
        state.dropLoading = false;
        state.subLocations = [];
      })

      .addCase(fetchCrops.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCrops.fulfilled, (state, action) => {
        state.loading = false;
        state.crops = action.payload;
      })
      .addCase(fetchCrops.rejected, (state) => {
        state.loading = false;
        state.crops = [];
      })

      .addCase(fetchWaterSources.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchWaterSources.fulfilled, (state, action) => {
        state.loading = false;
        state.wtrSources = action.payload;
      })
      .addCase(fetchWaterSources.rejected, (state) => {
        state.loading = false;
        state.wtrSources = [];
      })

      .addCase(fetchIrrigationType.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIrrigationType.fulfilled, (state, action) => {
        state.loading = false;
        state.irrType = action.payload;
      })
      .addCase(fetchIrrigationType.rejected, (state) => {
        state.loading = false;
        state.irrType = [];
      })

      .addCase(fetchSchemeType.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSchemeType.fulfilled, (state, action) => {
        state.loading = false;
        state.schemeType = action.payload;
      })
      .addCase(fetchSchemeType.rejected, (state) => {
        state.loading = false;
        state.schemeType = [];
      })

      .addCase(fetchLoship.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLoship.fulfilled, (state, action) => {
        state.loading = false;
        state.loship = action.payload;
      })
      .addCase(fetchLoship.rejected, (state) => {
        state.loading = false;
        state.loship = [];
      })

      .addCase(fetchSchemeCrops.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSchemeCrops.fulfilled, (state, action) => {
        state.loading = false;
        state.schemeCrop = action.payload;
      })
      .addCase(fetchSchemeCrops.rejected, (state) => {
        state.loading = false;
        state.schemeCrop = [];
      })

      .addCase(fetchLicense.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLicense.fulfilled, (state, action) => {
        state.loading = false;
        state.iwuaLicenses = action.payload;
      })
      .addCase(fetchLicense.rejected, (state) => {
        state.loading = false;
        state.iwuaLicenses = [];
      })

      .addCase(fetchSchemeBlocks.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSchemeBlocks.fulfilled, (state, action) => {
        state.loading = false;
        state.schemeBlocks = action.payload;
      })
      .addCase(fetchSchemeBlocks.rejected, (state) => {
        state.loading = false;
        state.schemeBlocks = [];
      })

      .addCase(fetchPeriods.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPeriods.fulfilled, (state, action) => {
        state.loading = false;
        state.periods = action.payload;
      })
      .addCase(fetchPeriods.rejected, (state) => {
        state.loading = false;
        state.periods = [];
      })

      .addCase(fetchMemberTypes.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMemberTypes.fulfilled, (state, action) => {
        state.loading = false;
        state.memberTypes = action.payload;
      })
      .addCase(fetchMemberTypes.rejected, (state) => {
        state.loading = false;
        state.memberTypes = [];
      })

      .addCase(fetchSubsidyType.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSubsidyType.fulfilled, (state, action) => {
        state.loading = false;
        state.subsidyTypes = action.payload;
      })
      .addCase(fetchSubsidyType.rejected, (state) => {
        state.loading = false;
        state.subsidyTypes = [];
      })

      .addCase(fetchSubsidySource.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSubsidySource.fulfilled, (state, action) => {
        state.loading = false;
        state.subsidySources = action.payload;
      })
      .addCase(fetchSubsidySource.rejected, (state) => {
        state.loading = false;
        state.subsidySources = [];
      })

      .addCase(fetchFundingMode.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchFundingMode.fulfilled, (state, action) => {
        state.loading = false;
        state.wtrFunding = action.payload;
      })
      .addCase(fetchFundingMode.rejected, (state) => {
        state.loading = false;
        state.wtrFunding = [];
      })

      .addCase(fetchWtrConvMeans.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchWtrConvMeans.fulfilled, (state, action) => {
        state.loading = false;
        state.wtrConvMeans = action.payload;
      })
      .addCase(fetchWtrConvMeans.rejected, (state) => {
        state.loading = false;
        state.wtrConvMeans = [];
      })

      .addCase(fetchWtrApplMode.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchWtrApplMode.fulfilled, (state, action) => {
        state.loading = false;
        state.wtrAppl = action.payload;
      })
      .addCase(fetchWtrApplMode.rejected, (state) => {
        state.loading = false;
        state.wtrAppl = [];
      })

      .addCase(fetchWtrAbstraction.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchWtrAbstraction.fulfilled, (state, action) => {
        state.loading = false;
        state.wtrAbstraction = action.payload;
      })
      .addCase(fetchWtrAbstraction.rejected, (state) => {
        state.loading = false;
        state.wtrAbstraction = [];
      })

      .addCase(fetchMrktHow.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMrktHow.fulfilled, (state, action) => {
        state.loading = false;
        state.mrktHow = action.payload;
      })
      .addCase(fetchMrktHow.rejected, (state) => {
        state.loading = false;
        state.mrktHow = [];
      }) 

      .addCase(fetchMangrCrops.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMangrCrops.fulfilled, (state, action) => {
        state.loading = false;
        state.mngrCrops = action.payload;
      })
      .addCase(fetchMangrCrops.rejected, (state) => {
        state.loading = false;
        state.mngrCrops = [];
      })

      .addCase(fetchDepts.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDepts.fulfilled, (state, action) => {
        state.loading = false;
        state.department = action.payload;
      })
      .addCase(fetchDepts.rejected, (state) => {
        state.loading = false;
        state.department = [];
      })

      .addCase(fetchUsrStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUsrStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.usrStatuses = action.payload;
      })
      .addCase(fetchUsrStatus.rejected, (state) => {
        state.loading = false;
        state.usrStatuses = [];
      })

      .addCase(fetchProfiles.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchProfiles.fulfilled, (state, action) => {
        state.loading = false;
        state.profiles = action.payload;
      })
      .addCase(fetchProfiles.rejected, (state) => {
        state.loading = false;
        state.profiles = [];
      })
        
    
      .addCase(fetchReportTree.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchReportTree.fulfilled, (state, action) => {
        state.loading = false;
        state.reportTree = action.payload?.data?.result; 
      })
      .addCase(fetchReportTree.rejected, (state) => {
        state.loading = false;
        state.reportTree = []; 
      })
      
      .addCase(fetchLovData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLovData.fulfilled, (state, action) => {
        state.loading = false;
        state.lovData = action?.payload?.data?.result;
      })
      .addCase(fetchLovData.rejected, (state) => {
        state.loading = false;
        state.lovData = [];
      })

      .addCase(fetchLovGridData.pending, (state) => {
        state.loadingGrid = true;
      })
      .addCase(fetchLovGridData.fulfilled, (state, action) => {
        state.loadingGrid = false;
        state.lovGrid = action?.payload;
      })
      .addCase(fetchLovGridData.rejected, (state) => {
        state.loadingGrid = false;
        state.lovGrid = [];
      })
       
      .addCase(generateReport.pending, (state) => {
        state.loadingGenerateReport = true;
      })
      .addCase(generateReport.fulfilled, (state, action) => {
        state.loadingGenerateReport = false;
      })
      .addCase(generateReport.rejected, (state) => {
        state.loadingGenerateReport = false;
      })

  },
});

export default fetchSlice.reducer;
export const { clearFetchObj,clearFetchObjByUrl } = fetchSlice.actions;
